import React from "react";
import { useSearchParams } from "react-router-dom";
import ParametresBoutique from "./ParametresBoutique";
// Un même formulaire conserve la saisie et les contrats lors d'un redimensionnement.
export default function ResponsiveParametresBoutique() {
  const [params] = useSearchParams();
  const storeId = Number(params.get("store_id"));
  return <ParametresBoutique initialStoreId={Number.isSafeInteger(storeId) && storeId > 0 ? storeId : undefined} />;
}
